import React from 'react';
import TextField from "@material-ui/core/TextField";
import {Field} from "react-final-form";

function TextInput(props) {
    const { onEnter, disabled, field, input, value, inputRef, meta: { touched, error, submitError } , ...rest} = props;

    if (field.type === 'number') {
        input.min = 1;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onEnter && onEnter(event);
        }
    }

    return (
        <TextField
            id={input.name}
            label={field.required ? <>{field.label} *</> : field.label}
            name={input.name}
            helperText={touched && (error||submitError) }
            error={touched && (error||submitError)}
            size={field.size || undefined}
            {...input}
            type={field.type === 'number' ? 'text' : (field.type || 'text')}
            InputProps={field.InputProps}
            inputProps={{
                onKeyDown: handleKeyDown,
                className: field.className,
                autoComplete: field.noAutocomplete ? 'off' : '',
                type: (field.type === 'number' || field.type === 'uppercase') ? 'text' : (field.type || 'text'),
            }}
            variant={field.variant || "outlined"}
            disabled={disabled}
            multiline={field.multiline || false}
            ref={inputRef}
            {
                ...(field.isCurrency ? {
                    onBlur: (event) => {
                        let value = event.target.value
                            .replace(/[^0-9.,]/g, '') // Remove invalid characters
                            .replace(/,/g, '.') // Standardize to one separator (e.g., ".")
                            .replace(/(\..*?)\./g, '$1') // Allow only one period

                        // Attempt to parse the value to a float
                        let parsedValue = parseFloat(value);

                        if (isNaN(parsedValue)) {
                            parsedValue = 0; // Default to 0 if parsing fails
                        }

                        // Format the parsed value to 2 decimal places
                        value = parsedValue.toFixed(2);

                        // Update the input value with the formatted result
                        input.onChange(value);
                    }
                }
                :
                {

                }
            )
            }
            onChange={(event) => {
                if(field.type === 'number') {
                    if (field.isCurrency) {
                        input.onChange(
                            event.target.value
                                .replace(/[^0-9.,]/g, '') // Remove invalid characters
                                .replace(/,/g, '.') // Standardize to one separator (e.g., ".")
                                .replace(/(\..*?)\./g, '$1') // Allow only one period
                        );
                    } else {
                        input.onChange(event.target.value.replace(/\D/g,''));
                    }
                    return;
                }
                if(field.type === 'uppercase') {
                    input.onChange(event.target.value.toUpperCase());
                    return;
                }
                input.onChange(event);
            }}

        />
    );
}

export default TextInput;
